import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import exportMethod9280c6 from './export'
/**
* @see \App\Http\Controllers\Creator\DashboardExportController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportController.php:18
* @route '/app/creator/dashboard/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/app/creator/dashboard/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\DashboardExportController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportController.php:18
* @route '/app/creator/dashboard/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\DashboardExportController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportController.php:18
* @route '/app/creator/dashboard/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportController.php:18
* @route '/app/creator/dashboard/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportController.php:18
* @route '/app/creator/dashboard/export'
*/
const exportMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportController.php:18
* @route '/app/creator/dashboard/export'
*/
exportMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportController.php:18
* @route '/app/creator/dashboard/export'
*/
exportMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

const dashboard = {
    export: Object.assign(exportMethod, exportMethod9280c6),
}

export default dashboard